import { backdropClasses } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
  },
  tableWrapper: {
    paddingBlock: 12,
  },
  pages: {
    background: "#fff",
    borderRadius: 8,
    padding: "24px",
  },
  headerSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "44px !important",
    width: "100%",
  },
  pageTitle: {
    fontSize: "24px !important",
    fontWeight: "500 !important",
    color: "#000",
  },
  searchContainer: {
    width: "300px",
  },
  searchInput: {
    width: "100%",
    background: "#fff",
    borderRadius: "30px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "30px",
    },
  },
  metricboxes: {
    marginBottom: "24px",
  },
  metricboxCard: {
    background: "#e4e5e7",
    borderRadius: "12px",
    padding: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
    boxSizing: "border-box",
  },
  metricboxContent: {
    display: "flex",
    flexDirection: "column",
  },
  metricTitle: {
    fontSize: "16px !important",
    fontWeight: "500 !important",
    color: "#6c757d",
    marginBottom: "8px !important",
  },
  metricValue: {
    fontSize: "36px !important",
    fontWeight: "bold !important",
    color: "#000",
  },
  metricIcon: {
    width: "80px",
    height: "auto",
    objectFit: "contain",
  },
  filtersContainer: {
    display: "flex",
    gap: "12px",
    "& .MuiTextField-root": {
      minWidth: "140px",
      background: "#fff",
    },
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    alignItems: "center",
  },
  buttonGroup: {
    "& .MuiButton-root": {
      background: "#2a2d34",
      color: "#fff",
      textTransform: "none",
      borderColor: "#3a3d45",
      "&:hover": {
        background: "#1e2025",
      }
    }
  },
  moreFiltersBtn: {
    background: "#2a2d34 !important",
    color: "#fff !important",
    textTransform: "none !important",
    "&:hover": {
      background: "#1e2025 !important",
    }
  },
  utilities: {
    marginBottom: "24px",
    width: "100%",
  },
  datePickerStyle: {
    "& .css-1jbvi91-MuiFormControl-root-MuiTextField-root": {
      width: "100%",
    },
    "& .css-1h0hk72-MuiFormLabel-root-MuiInputLabel-root": {
      top: "-5px",
    },
    "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "",
    },
  },
  layout: {
    background: "#EAEDEF",
    height: "calc(100vh - 70px)",
    overflowY: "auto",
  },
  title: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    padding: "20px 0px",
  },
  editIcon: {
    border: `1px solid #11823b`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#11823b",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  deleteIcon: {
    border: `1px solid #ff2020db`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ff2020db",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  historyIcon: {
    border: `1px solid #f140a9`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#000000",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  actiontypo: {
    padding: 2,
    color: "#fff",
    "&.MuiTypography-subtitle2": {
      fontSize: 14,
    },
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: 8,
    "& .MuiTypography-root": {
      fontWeight: 500,
    },
    "& .MuiButton-root": {
      color: "gray",
      textTransform: "capitalize",
      border: "1px solid #c5baba",
      "&:hover": {
        border: "1px solid #848181",
        backgroundColor: "#fff",
      },
    },
  },
  roundedFilter: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "30px",
      background: "#fff",
      "& fieldset": {
        borderColor: "#e0e0e0",
      },
      "&:hover fieldset": {
        borderColor: "#ccc",
      },
    },
    "& .MuiSelect-select": {
      padding: "8px 14px",
      fontSize: "14px",
      color: "#333",
    },
    "& input": {
      padding: "8px 14px",
      fontSize: "14px",
      color: "#333",
    }
  },
  dataGridTable: {
    paddingBlock: 20,
    width: "100%",
    "& .MuiDataGrid-root": {
      border: "none",
    },
    "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaders": {
      background: "#e4e5e7",
      borderBottom: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 600,
      fontSize: 14,
      color: "#333",
    },
    "& .MuiDataGrid-iconSeparator ": {
      display: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 6,
      },
    },
    "& .MuiDataGrid-footerContainer": {
      display: "none",
    },
    "& .MuiDataGrid-cell": {
      whiteSpace: "normal !important",
      wordWrap: "break-word",
      borderBottom: "none",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiDataGrid-row:nth-of-type(odd)": {
      backgroundColor: "#fff",
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
      backgroundColor: "#fafafa",
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  linkText: {
    "& .MuiTypography-root": {
      color: "#0f5fff",
      cursor: "pointer",
    },
  },
  spacing: {
    paddingBlockStart: 4,
  },
  iconsWrapper: {
    display: "flex",
    gap: 8,
    "& .MuiButtonBase-root": {
      background: "#3588fe",
      color: "#fff",
      padding: 2,
      borderRadius: 15,
    },
  },
  status: {
    color: "#fff",
    padding: 6,
    borderRadius: 15,
  },
  deleteIcon: {
    border: `1px solid #ff2020db`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ff2020db",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
}));


export default useStyles;
